var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.showHiddenIFrame)?_c('IFrame',{attrs:{"name":"hiddenIFrame","src":_vm.iFrameSource,"css-style":{
            position: 'absolute',
            width: 0,
            height: 0,
            border:0
        }},on:{"close":function($event){return _vm.hideIFrame()}}}):_vm._e(),(false)?_c('v-btn',{attrs:{"small":"","disabled":!_vm.silentIframeEnabled(),"depressed":""},on:{"click":_vm.toggleIFrame}},[_vm._v(" refresh token - "+_vm._s(Math.round(_vm.tokenTimeLeft / 1000))+" s ")]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }